export default function ButtonDialogSecondary({label,clickEvent}){
    return(
        <div className="dialog-action-2" onClick={clickEvent}>{label}</div>
    )
}